// Product-card hover video.
//
// The markup ships with preload="none" and no autoplay, so a collection page
// costs nothing in video bytes until someone actually points at a card. Touch
// devices never hover, so they never load any of it.
(function () {
  // No `(hover: hover)` gate: emulated and hybrid devices report it wrongly.
  // Touch devices simply never fire mouseenter, so binding costs them nothing
  // and preload="none" means they download no video either way.
  var started = new WeakSet();

  function play(video) {
    // No load() first — it resets the element and the play() right after loses
    // the race. With preload="none", play() starts the fetch by itself.
    started.add(video);
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function stop(video) {
    video.pause();
    try { video.currentTime = 0; } catch (e) {}
  }

  function bind(card) {
    var video = card.querySelector('.card__media-hover-video');
    if (!video || card.dataset.oliviaHoverBound) return;
    card.dataset.oliviaHoverBound = '1';
    card.addEventListener('mouseenter', function () { play(video); });
    card.addEventListener('mouseleave', function () { stop(video); });
  }

  function scan(root) {
    (root || document).querySelectorAll('.card-wrapper, .card').forEach(bind);
  }

  scan();
  // Collections paginate and filter in place — pick up cards added later.
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) scan(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
